/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-09-18 10:11:25
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-10-27 17:33:27
 * @FilePath: \合联\oms\src\api\finance\risk_control.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

// 获取列表
export const getRiskControl = data => {
  return axios.request({
    url: "/finance/arrears/list",
    method: "post",
    data
  });
};

export const upload = data => {
  return axios.request({
    url: "/finance/arrears/upload",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};

